import { useEffect, useState } from "react";
import SEO from "../components/SEO";

const STATUS_MAP = {
  success: { emoji: "✅", title: "Оплата успішна!", color: "#16a34a" },
  processing: { emoji: "⏳", title: "Обробляється...", color: "#ca8a04" },
  hold: { emoji: "🔒", title: "Кошти заблоковано", color: "#2563eb" },
  failure: { emoji: "❌", title: "Оплата не вдалась", color: "#dc2626" },
  reversed: { emoji: "↩️", title: "Повернення коштів", color: "#7c3aed" },
  expired: { emoji: "⌛", title: "Рахунок прострочено", color: "#6b7280" },
  created: { emoji: "📋", title: "Рахунок створено", color: "#6b7280" },
};

export default function PaymentResult() {
  const [status, setStatus] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const invoiceId = sessionStorage.getItem("mono_invoice_id");
    if (!invoiceId) {
      setError("Рахунок не знайдено");
      return;
    }

    fetch(`/api/payment/status?invoiceId=${invoiceId}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.error) throw new Error(data.error);
        setInvoice(data);
        setStatus(data.status);
        // Якщо ще обробляється — перевіряємо знову через 3 сек
        if (data.status === "processing") {
          setTimeout(() => window.location.reload(), 3000);
        } else {
          sessionStorage.removeItem("mono_invoice_id");
        }
      })
      .catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div style={styles.container}>
        <SEO
          title="Помилка оплати"
          description="Помилка оплати "
          url="https://zori.place/payment/result"
        />
        <p style={{ color: "#dc2626", fontSize: 18 }}>⚠️ {error}</p>
        <a href="/" style={styles.link}>
          На головну
        </a>
      </div>
    );
  }

  if (!status) {
    return (
      <div style={styles.container}>
        <SEO
          title="Статус оплати"
          description="Перевіряємо статус оплати..."
          url="https://zori.place/payment/result"
        />
        <p style={{ color: "#666" }}>Перевіряємо статус оплати...</p>
      </div>
    );
  }

  const info = STATUS_MAP[status] || STATUS_MAP.created;

  return (
    <div style={styles.container}>
      <SEO
        title="Статус оплати"
        description="Статус оплати"
        url="https://zori.place/payment/result"
      />
      <div style={{ ...styles.card, borderColor: info.color }}>
        <div style={{ fontSize: 52 }}>{info.emoji}</div>
        <h2 style={{ color: info.color, margin: "12px 0 4px" }}>{info.title}</h2>

        {invoice && (
          <div style={styles.details}>
            <Row label="Сума" value={`${invoice.amount / 100} ₴`} />
            {invoice.reference && <Row label="Замовлення" value={invoice.reference} />}
            {invoice.paymentInfo?.maskedPan && (
              <Row label="Картка" value={invoice.paymentInfo.maskedPan} />
            )}
          </div>
        )}

        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
          <a href="/" style={{ ...styles.btn, background: "#000" }}>
            На головну
          </a>
          {status !== "success" && (
            <a href="/checkout" style={{ ...styles.btn, background: info.color }}>
              Спробувати знову
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <span style={{ color: "#888" }}>{label}</span>
      <span style={{ fontWeight: 600 }}>{value}</span>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "sans-serif",
    background: "#f9fafb",
    padding: 20,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "40px 32px",
    textAlign: "center",
    maxWidth: 400,
    width: "100%",
    border: "2px solid",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  details: {
    marginTop: 20,
    textAlign: "left",
    fontSize: 15,
  },
  btn: {
    color: "#fff",
    textDecoration: "none",
    padding: "10px 20px",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
  },
  link: { color: "#2563eb", marginTop: 12, display: "block" },
};
